import React from "react";

export function TodosError({ error }) {
    return <p>{error}</p>    
};